export const invite = {
    fuwutiaokuan: '《Syarat Layanan》',
    yinsizhengce: '《Kebijakan Privasi》',
    fzcg: 'Berhasil disalin',
    yqhy: "Undang Teman",
    fxlj: "Bagikan Tautan",
    register_now: 'Daftar Sekarang',
    phone: 'Telepon',
    email: 'Email',
    placehold_phone: 'Silakan masukkan nomor telepon Anda',
    placehold_email: 'Silakan masukkan email Anda',
    placehold_code: 'Kode undangan',
    argee: 'Saya telah membaca dan menyetujui',
    agreement: '《Perjanjian Pengguna BiKing》',
    register: 'Daftar',
    phone_code: 'Kode verifikasi SMS',
    email_code: 'Kode verifikasi email',
    code_to_phone: 'Kode verifikasi telah dikirim melalui SMS ke telepon Anda',
    code_to_email: 'Kode verifikasi telah dikirim ke email Anda',
    has_sent: 'Kode verifikasi telah dikirim ke:',
    resend: 'Kirim ulang',
    send_code: 'Kirim kode verifikasi',
    unable_code: 'Tidak menerima kode verifikasi?',
    set_pwd: 'Atur kata sandi',
    placehold_pwd: 'Silakan masukkan kata sandi Anda',
    submit: 'Kirim',
    error_phone: 'Silakan masukkan nomor telepon yang benar',
    error_email: 'Format email tidak benar, silakan masukkan kembali',
    error_checked: 'Silakan centang persetujuan terlebih dahulu',
    text: 'Format kata sandi salah, kata sandi harus 8-32 karakter, mengandung huruf besar, huruf kecil, dan angka.',
    validate: 'Silakan selesaikan verifikasi',
    register_success: 'Pendaftaran berhasil!',
    welcome: 'Selamat datang di BiKing',
    start_trade: 'Isi ulang cryptocurrency untuk mulai trading',
    safe: 'Berbagai metode isi ulang, aman, mudah untuk trading cryptocurrency',
    pay_type: 'Beli dan jual cryptocurrency melalui kartu bank atau metode pembayaran lainnya',
    right_now_download: 'Pergi unduh sekarang',
    right_download: 'Pergi unduh',
    'Please_enter_correct_phone_number': 'Silakan masukkan nomor telepon yang benar',
    'Referral_code': 'Silakan masukkan kode undangan Anda',
    'I_have_read_and_agree': 'Saya telah membaca dan menyetujui',
    'BiKing_User_Agreement': '《Perjanjian Pengguna BiKing》',
    'Please_enter_password': 'Silakan masukkan kata sandi Anda',
    'Email_verification_code': 'Kode verifikasi email',
    'SMS_code': 'Kode verifikasi SMS',
    'Incorrect_email_format_please_reenter': 'Format email tidak benar, silakan masukkan kembali',
    'Please_read_and_agree_User_Agreement': 'Silakan baca dan setujui perjanjian pengguna',
    'Sent_code_to': 'Kode verifikasi telah dikirim ke',
    zjff: 'Distribusi langsung!',
    ycxdz: 'Sekaligus sampai!',
    bbsy: '0 biaya dapatkan keuntungan 100x!',
    sdly: 'Tiga alasan memilih BiKing',
    aqfktx: 'Sistem manajemen risiko keamanan kelas dunia',
    aqhg: 'Aman dan合规, jaringan nilai yang terpercaya, arsitektur terdistribusi profesional dan sistem anti DDOS',
    qqbthyytd: 'Tim operasi lokal global',
    qqbj: 'Jaringan global, layanan lokal di banyak negara, membangun ekosistem blockchain multi-bisnis',
    fwtx: 'Membangun kembali sistem layanan berpusat pada pengguna',
    yhzs: 'Pengguna pertama, mekanisme kompensasi unik, mendirikan dana perlindungan pengguna',
    jslc: 'Proses membuka',
    zcwcjkjs: 'Setelah pendaftaran selesai, 1188USDT akan didistribusikan dalam bentuk saldo akun bonus, buka akun bonus untuk mengaktifkannya.',
    czts: 'Contoh: Setelah berhasil mendaftar, gunakan 1000USDT yang diterima untuk membeli posisi long BTC dengan leverage 20x, ketika BTC naik 1%, Anda mendapatkan keuntungan 20%, yaitu 200USDT, keuntungan ini dapat langsung ditarik.',
    zhu: 'Catatan:',
    qzlqyky: '1188USDT didistribusikan secara bertahap per transaksi, dapat digunakan untuk semua jenis kontrak',
    gqql: '1188USDT masa berlaku 1 bulan, kedaluwarsa akan direset',
}


// WEBPACK FOOTER //
// ./src/i18n/lang/invite/ba.js